import { useStatsigClient } from '@statsig/react-bindings'

export const STATSIG_GATE_NAMES = {
  SUBSCRIPTIONS_ENABLED: 'subscriptions_enabled',
  SUBSCRIPTION_OTP_ENABLED: 'subscription_otp_enabled',
  SUBSCRIPTION_ADDRESS_UPDATE_MESSAGE: 'subscription_address_update_message',
  DECAGON_ENABLED_FOR_LOGGED_OUT_USERS: 'decagon_enabled_for_logged_out_users',
  INSEAM_ATTRIBUTE_ENABLED: 'inseam_attribute_enabled',
  DISABLE_EDD_HOMEPAGE_RECOMMENDATIONS: 'disable_edd_homepage_recommendations',
  MIGRATE_WHITE_GLOVE_DELIVERY_TAG: 'migrate_white_glove_delivery_tag',
  EFA_CHECKOUT_REDIRECT: 'efa_checkout_redirection',
  CLP_RESPONSIVE_FILTERS: 'clp_responsive_filters',
  RESPONSIVE_CTA_LOADING_ENABLED: 'ssr_responsive_cta',
} as const

export const STATSIG_DYNAMIC_CONFIG_NAMES = {
  ENABLE_WRITE_REVIEW_ON_B2B_PDP: 'enableWriteReviewOnB2BPdp',
} as const

export type StatsigGateName = (typeof STATSIG_GATE_NAMES)[keyof typeof STATSIG_GATE_NAMES]
/**
 * Hook to check Statsig gate status
 * @param gateName - The name of the gate to check
 * @returns boolean - true if gate is enabled, false otherwise
 */
export const useStatsigGate = (gateName: StatsigGateName): boolean => {
  const { checkGate } = useStatsigClient()
  try {
    return checkGate(gateName)
  } catch (error) {
    // Log the error but don't throw to prevent breaking non-critical features
    console.error('Failed while checking statsig gate', error)
    return false
  }
}
